export const ClosingInfoCardId = {
  EARLIEST_CLOSING_DATE: 'earliestClosingDate',
  FIRST_CLOSING_DATE: 'firstClosingDate',
  CLOSING_DATE: 'closingDate',
  CLOSING_LOCATION: 'closingLocation',
};

export const FundingInfoCardId = {
  FUNDING_TYPE: 'fundingType',
  FUNDING_NUMBER: 'fundingNumber',
  WIRE_AMOUNT: 'wireAmount',
  ADVANCE_AMOUNT: 'advanceAmount',
  WAREHOUSE_BANK: 'warehouseBank',
};

export const LoanClosingSearchParams = {
  AMORTIZATION_SCHEDULE: 'amortizationSchedule',
};
